/**
 * Whole-Doc font-size stepping (A− / A+). The chosen step is persisted in
 * the frame's `metadata.font_size` and rendered via the `--doc-font-scale`
 * CSS variable (`doc-editor.css`).
 */

export const DOC_FONT_SIZE_STEPS = ["sm", "md", "lg", "xl"] as const;

export type DocFontSize = (typeof DOC_FONT_SIZE_STEPS)[number];

export const DOC_FONT_SCALES: Record<DocFontSize, number> = {
  sm: 0.85,
  md: 1,
  lg: 1.2,
  xl: 1.45,
};

export function normalizeDocFontSize(value: unknown): DocFontSize {
  return DOC_FONT_SIZE_STEPS.includes(value as DocFontSize)
    ? (value as DocFontSize)
    : "md";
}

export function stepDocFontSize(
  current: DocFontSize,
  direction: 1 | -1,
): DocFontSize {
  const index = DOC_FONT_SIZE_STEPS.indexOf(current) + direction;
  const clamped = Math.min(Math.max(index, 0), DOC_FONT_SIZE_STEPS.length - 1);
  return DOC_FONT_SIZE_STEPS[clamped] as DocFontSize;
}
